import React from "react";
import { toast, ToastOptions } from "react-toastify";

const DEFAULT_AUTO_CLOSE_TIME = 10000;

export function showSuccessMessage(message: string | React.ReactNode, options?: ToastOptions) {
  toast.success(message, {
    position: "bottom-right",
    className: "bg-success text-white",
    autoClose: options?.autoClose ?? DEFAULT_AUTO_CLOSE_TIME,
    ...options
  });
}

export function showErrorMessage(message: string | React.ReactNode, options?: ToastOptions) {
  toast.error(message, {
    position: "bottom-right",
    className: "bg-error text-white",
    autoClose: options?.autoClose ?? DEFAULT_AUTO_CLOSE_TIME,
    closeOnClick: options?.closeOnClick ?? true,
    ...options
  });
}

export function showWarningMessage(message: string | React.ReactNode, options?: ToastOptions) {
  toast.warning(message, {
    position: "bottom-right",
    className: "bg-warning text-white",
    autoClose: options?.autoClose ?? DEFAULT_AUTO_CLOSE_TIME,
    ...options
  });
}
